import {
    Link as ChakraLink,
    Text,
    Input,
    Box,
    Badge,
    SimpleGrid,
    Button,
    IconButton,
    Select,
    Heading,
    Avatar,
    Grid,
    GridItem,
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Center,
    Divider,
    Spinner,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Progress,
    Tooltip,
    Alert,
    AlertIcon,
    HStack,
    Spacer,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Menu,
    VStack,
    useDisclosure,
    Flex,
    InputGroup,
    Collapse,
    Icon,
  } from '@chakra-ui/react'



import InvoiceAttachmentPreviewPanel from './InvoiceAttachmentPreviewPanel'

import CurrencyInput from 'react-currency-input-field';


import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";

import {IoPrint,IoGift, IoNotifications,IoRemoveCircle, IoChevronForwardOutline,IoChevronBack, IoChevronDown, IoChevronUp,  IoBriefcase, IoInformationCircle, IoCheckmarkDoneCircleSharp, IoCash,IoCheckmarkCircle, IoDownload ,IoCloudUpload,IoSave,IoDocumentAttachOutline , IoPersonAdd, IoAddCircle, IoShare,IoTrash, IoPersonCircleSharp, IoTimer, IoCloseCircle, IoAddCircleOutline, IoChatbubbleEllipsesOutline, IoRefresh, IoSettingsOutline} from 'react-icons/io5';

import React, { useEffect, useState, useRef,Component } from "react";
import { withInvoiceQueueConsumerTarget } from "../utils/url";
import AllIcons from '../constants/AllIcons';
import { Select as ChakraReactSelect } from "chakra-react-select";
import { BookingAccountSkr3Select } from "./BookingAccountSkr3Select";
import { BuKeySelect } from "./BuKeySelect";
import SelectCurrency from './SelectCurrency';
import SelectBudget from './SelectBudget';
import ChangeLogElement from './ChangeLogElement';
import InvoiceStatusElement from './InvoiceStatusElement';
import SelectInvoiceType from './SelectInvoiceType';
import TravelExpensesElement from './TravelExpenseElement';
import DeleteModal from './DeleteModal';
import TradingPartnerManager from './CreditorManager';
import InvoiceCommentsSection from './comments/InvoiceCommentsSection';
import TransactionSelectorDrawer, { type TransactionSelectorItem } from './TransactionSelectorDrawer';
import TradingPartnerSelectorDrawer from './TradingPartnerSelectorDrawer';
import axios from 'axios';


import { useTranslation } from 'next-i18next'




const containerStyle = {
  width: '100%',
  height: '500px',
};

type BookingEntry = {
  _id?: string;
  amount?: string; // gross amount of this entry
  baseAmount?: string;
  account?: string; // SKR03 account
  buSchluessel?: string;
  documentField1?: string;
  documentField2?: string;
  bookingText?: string;
  euTaxRate?: string;
  taxRate?: string;
  performanceDate?: string;
  dueDate?: string;
};

function toCents(val: unknown): number {
  if (val == null) return 0;
  if (typeof val === "number") return Number.isFinite(val) ? Math.round(val * 100) : 0;
  if (typeof val !== "string") return 0;
  const raw = val.trim().replace(/\s/g, "");
  const hasComma = raw.includes(",");
  const hasDot = raw.includes(".");
  // If there's a comma, assume DE format: '.' thousands, ',' decimals.
  // If there's only a dot, assume dot is decimal separator (EN/ISO).
  const normalized = hasComma
    ? raw.replace(/\./g, "").replace(",", ".")
    : hasDot
      ? raw
      : raw;
  const cleaned = normalized.replace(/[^0-9.-]/g, "");
  const n = parseFloat(cleaned);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
}

const center = {
  lat: 52.52, // Default coordinates (Berlin, for example)
  lng: 13.405,
};

function InvoiceDrawerSection({
  title,
  description,
  rightElement,
  icon,
  hideHeader,
  collapsible = true,
  defaultOpen = true,
  children,
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  rightElement?: React.ReactNode;
  icon?: React.ReactNode;
  hideHeader?: boolean;
  collapsible?: boolean;
  defaultOpen?: boolean;
  children: React.ReactNode;
}) {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: defaultOpen });

  return (
    <Box
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="lg"
      bg="white"
      p={3}
    >
      {!hideHeader && (
        <Box
          onClick={collapsible ? onToggle : undefined}
          cursor={collapsible ? "pointer" : "default"}
          userSelect="none"
        >
          <Flex gap={2} align="flex-start" mb={2}>
            <HStack spacing={2} flex="1" minW={0} align="flex-start">
              {icon ? (
                <Box mt={0.5} color="gray.600">
                  {icon}
                </Box>
              ) : null}
              <Box flex="1" minW={0}>
                <Heading as="h3" size="sm" noOfLines={1}>
                  {title}
                </Heading>
                {description && (
                  <Text mt={0.5} fontSize="sm" color="gray.500">
                    {description}
                  </Text>
                )}
              </Box>
            </HStack>
            <HStack
              spacing={2}
              onClick={(e) => e.stopPropagation()}
              align="center"
            >
              {rightElement}
              {collapsible ? (
                <Box color="gray.600" mt={0.5}>
                  {isOpen ? <IoChevronUp /> : <IoChevronDown />}
                </Box>
              ) : null}
            </HStack>
          </Flex>
        </Box>
      )}
      {collapsible ? (
        <Collapse in={isOpen} animateOpacity>
          {children}
        </Collapse>
      ) : (
        children
      )}
    </Box>
  );
}


const InvoiceDetailDrawer = ({
  createInvoiceType,
  setBulkUploadCounterFinished,
  bulkUploadSettings,
  setBulkInsertData,
  bulkInsertData,
  uploadInProgress,
  categoriesData,
  userData,
  setUploadInProgress,
  editInvoiceReadonly,
  previewBackwards, 
  previewForwards, 
  editInvoiceReadonlyReason,
  loadInvoices,
  invoiceTypesData,
  loadBudgetSpending,
  loadSingleInvoices,
  scroller,
  rekeningData,
  setRekeningData,
  invoiceIsOpen,
  session,
  setChangedInvoices,
  invoiceOnClose,
  setSelectedInvoice,
  selectedInvoice,
  userNotification,
  createInvoice,
  setCreateInvoice,
  setIsDuplicateModalOpen,
  setDuplicateCurrentFile,
  setDuplicateUserDecision
}) => {

    const {t} = useTranslation('common')

    const { isOpen: isCloseEditWithoutSave, onOpen: onCloseEditWithoutSaveOpen, onClose: onCloseEditWithoutSaveClose } = useDisclosure()

    const [selectedDay, setSelectedDay] = useState({
        year: new Date().getFullYear(),
        month: new Date().getMonth() +1,
        day: new Date().getUTCDate(),
      });

    type InvoiceDrawerMainTab = "settings" | "comments" | "activity";
    const [drawerMainTab, setDrawerMainTab] = useState<InvoiceDrawerMainTab>("settings");
    const openedInvoiceKey = createInvoice
      ? "new"
      : String(rekeningData?.[selectedInvoice]?._id ?? `idx-${selectedInvoice}`);

    useEffect(() => {
      if (!invoiceIsOpen) return;
      setDrawerMainTab("settings");
    }, [invoiceIsOpen, openedInvoiceKey, createInvoice]);

    const countryListAllowance = [
      {
        name: "Afghanistan",
        small: 20,
        large: 30,
        code: "AF"
      },
      {
        name: "Albania",
        small: 18,
        large: 27,
        code: "AL"
      },
      {
        name: "Algeria",
        small: 20,
        large: 30,
        code: "DZ"
      },
      {
        name: "Andorra",
        small: 33,
        large: 50,
        code: "AD"
      },
      {
        name: "Angola",
        small: 26,
        large: 39,
        code: "AO"
      },
      {
        name: "Argentina",
        small: 32,
        large: 47,
        code: "AR"
      },
      {
        name: "Armenia",
        small: 24,
        large: 36,
        code: "AM"
      },
      {
        name: "Australia - Canberra",
        small: 31,
        large: 46,
        code: "AU-CBR"
      },
      {
        name: "Australia - Sydney",
        small: 36,
        large: 52,
        code: "AU-SYD"
      },
      {
        name: "Australia",
        small: 31,
        large: 46,
        code: "AU"
      },
      {
        name: "Austria",
        small: 33,
        large: 50,
        code: "AT"
      },
      {
        name: "Belgium",
        small: 34,
        large: 51,
        code: "BE"
      },
      {
        name: "Brazil - Rio de Janeiro",
        small: 28,
        large: 41,
        code: "BR-RIO"
      },
      {
        name: "Brazil - Sao Paulo",
        small: 35,
        large: 52,
        code: "BR-SP"
      },
      {
        name: "Brazil",
        small: 24,
        large: 36,
        code: "BR"
      },
      {
        name: "Canada - Ottawa",
        small: 36,
        large: 54,
        code: "CA-OTT"
      },
      {
        name: "Canada - Toronto",
        small: 42,
        large: 63,
        code: "CA-TOR"
      },
      {
        name: "Canada - Vancouver",
        small: 42,
        large: 63,
        code: "CA-VAN"
      },
      {
        name: "Canada",
        small: 31,
        large: 46,
        code: "CA"
      },
      {
        name: "China - Beijing",
        small: 32,
        large: 48,
        code: "CN-PEK"
      },
      {
        name: "China - Shanghai",
        small: 39,
        large: 58,
        code: "CN-SHA"
      },
      {
        name: "China",
        small: 32,
        large: 48,
        code: "CN"
      },
      {
        name: "Denmark",
        small: 33,
        large: 50,
        code: "DK"
      },
      {
        name: "Egypt",
        small: 20,
        large: 30,
        code: "EG"
      },
      {
        name: "Finland",
        small: 36,
        large: 54,
        code: "FI"
      },
      {
        name: "France - Paris",
        small: 39,
        large: 58,
        code: "FR-PAR"
      },
      {
        name: "France",
        small: 36,
        large: 53,
        code: "FR"
      },
      {
        name: "Germany",
        small: 16,
        large: 24,
        code: "DE"
      },
      {
        name: "Greece",
        small: 35,
        large: 52,
        code: "GR-ATH"
      },
      {
        name: "Greece",
        small: 27,
        large: 40,
        code: "GR"
      },
      {
        name: "Hungary",
        small: 23,
        large: 34,
        code: "HU"
      },
      {
        name: "India - Mumbai",
        small: 33,
        large: 50,
        code: "IN-BOM"
      },
      {
        name: "India - New Delhi",
        small: 33,
        large: 50,
        code: "IN-DEL"
      },
      {
        name: "India",
        small: 21,
        large: 32,
        code: "IN"
      },
      {
        name: "Indonesia",
        small: 24,
        large: 36,
        code: "ID"
      },
      {
        name: "Ireland",
        small: 39,
        large: 58,
        code: "IE"
      },
      {
        name: "Israel",
        small: 44,
        large: 66,
        code: "IL"
      },
      {
        name: "Italy - Milan",
        small: 32,
        large: 48,
        code: "IT-MIL"
      },
      {
        name: "Italy - Rome",
        small: 39,
        large: 58,
        code: "IT-ROM"
      },
      {
        name: "Italy",
        small: 29,
        large: 44,
        code: "IT"
      },
      {
        name: "Japan - Tokyo",
        small: 52,
        large: 78,
        code: "JP-TYO"
      },
      {
        name: "Japan",
        small: 38,
        large: 57,
        code: "JP"
      },
      {
        name: "Kenya",
        small: 32,
        large: 48,
        code: "KE"
      },
      {
        name: "Malaysia",
        small: 24,
        large: 36,
        code: "MY"
      },
      {
        name: "Mexico",
        small: 31,
        large: 46,
        code: "MX"
      },
      {
        name: "Netherlands",
        small: 32,
        large: 47,
        code: "NL"
      },
      {
        name: "New Zealand",
        small: 39,
        large: 58,
        code: "NZ"
      },
      {
        name: "Nigeria",
        small: 31,
        large: 46,
        code: "NG"
      },
      {
        name: "Norway",
        small: 50,
        large: 75,
        code: "NO"
      },
      {
        name: "Poland - Breslau",
        small: 27,
        large: 33,
        code: "PL-WRO"
      },
      {
        name: "Poland - Danzig",
        small: 27,
        large: 33,
        code: "PL-GDN"
      },
      {
        name: "Poland - Krakau",
        small: 27,
        large: 33,
        code: "PL-KRK"
      },
      {
        name: "Poland - Warsaw",
        small: 29,
        large: 34,
        code: "PL-WAW"
      },
      {
        name: "Poland",
        small: 20,
        large: 29,
        code: "PL"
      },
      {
        name: "Portugal - Lisbon",
        small: 32,
        large: 47,
        code: "PT-LIS"
      },
      {
        name: "Portugal",
        small: 29,
        large: 44,
        code: "PT"
      },
      {
        name: "Russia - Moscow",
        small: 40,
        large: 60,
        code: "RU-MOW"
      },
      {
        name: "Russia",
        small: 30,
        large: 45,
        code: "RU"
      },
      {
        name: "Saudi Arabia",
        small: 28,
        large: 42,
        code: "SA"
      },
      {
        name: "South Africa - Johannesburg",
        small: 31,
        large: 46,
        code: "ZA-JNB"
      },
      {
        name: "South Africa - Cape Town",
        small: 31,
        large: 46,
        code: "ZA-CPT"
      },
      {
        name: "South Africa",
        small: 30,
        large: 45,
        code: "ZA"
      },
      {
        name: "Spain - Madrid",
        small: 44,
        large: 66,
        code: "ES-MAD"
      },
      {
        name: "Spain - Barcelona",
        small: 44,
        large: 66,
        code: "ES-BCN"
      },
      {
        name: "Spain",
        small: 34,
        large: 51,
        code: "ES"
      },
      {
        name: "Sweden",
        small: 35,
        large: 52,
        code: "SE"
      },
      {
        name: "Switzerland - Geneva",
        small: 43,
        large: 65,
        code: "CH-GVA"
      },
      {
        name: "Switzerland",
        small: 33,
        large: 50,
        code: "CH"
      },
      {
        name: "Turkey - Istanbul",
        small: 29,
        large: 44,
        code: "TR-IST"
      },
      {
        name: "Turkey",
        small: 24,
        large: 36,
        code: "TR"
      },
      {
        name: "United Arab Emirates",
        small: 32,
        large: 48,
        code: "AE"
      },
      {
        name: "UK - London",
        small: 44,
        large: 66,
        code: "UK-LON"
      },
      {
        name: "UK",
        small: 35,
        large: 52,
        code: "UK"
      },
      {
        name: "USA - New York City",
        small: 44,
        large: 66,
        code: "US-NYC"
      },
      {
        name: "USA - Washington, D.C.",
        small: 44,
        large: 66,
        code: "US-WDC"
      },
      {
        name: "USA - Atlanta",
        small: 52,
        large: 77,
        code: "US-ATL"
      },
      {
        name: "USA - Boston",
        small: 42,
        large: 63,
        code: "US-BOS"
      },
      {
        name: "USA - Chicago",
        small: 44,
        large: 66,
        code: "US-CHI"
      },
      {
        name: "USA - Houston",
        small: 41,
        large: 62,
        code: "US-HOU"
      },
      {
        name: "USA - Los Angeles",
        small: 43,
        large: 64,
        code: "US-LAX"
      },
      {
        name: "USA - Miami",
        small: 44,
        large: 65,
        code: "US-MIA"
      },
      {
        name: "USA - San Francisco",
        small: 40,
        large: 59,
        code: "US-SFO"
      },
      {
        name: "USA",
        small: 40,
        large: 60,
        code: "US"
      }
    ];
    


    const emptyInvoice = {
        _id: undefined,
        status: "",
        invoiceKind: "invoice",
        category:"",
        tradingPartner: "",
        clearingAccount: "",
        // legacy (was per invoice) - do not rely on it anymore
        bookingAccountSkr3: "",
        // new: booking records per invoice (Buchungssätze) - backend uses `bookingRecords`
        bookingRecords: [] as BookingEntry[],
        uuid:"",
        shop:"",
        invoiceNumber: "",
        total:"0",
        tax:"0",
        totalNet:"0",
        mwst:"0",
        date:new Date().toUTCString(),
        items:[],
        scanAttached:"",
        scanAttachedMD5:"",
        location:{},
        paymentType:"",
        invoiceText:"",
        author: "",
        authorData:[{name:""}],
        currency: "EUR",
        changelog: [],
        travelExpense:{},
        transactionType: "incoming",
        taxPositions: [
          {
            taxRate: "19",
            value: "0",
            valueNet: "0",
            valueTax: ""
          }
        ],
        invoiceType: undefined,
        invoiceStatus: undefined
      };

      const emptyTravelExpense = {
          locationFrom:"",
          locationTo:"",
          transportation:"train",
          transportationDistance:"0",
          breakfasts:0,
          lunches:0,
          dinners:0,
          startDate: null,
          endDate:null,
          country: "DE",
          allowanceSmall: "14",
          allowanceBig: "28",
          meals:[]
      };

  const [newInvoice, setNewInvoice] = useState(emptyInvoice);

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const [editInvoiceModified, setEditInvoiceModified] = useState(false);

  const [saveInvoiceLoading, setSaveInvoiceLoading] = useState(false);
  const [editInvoiceErrorArray, setEditInvoiceErrorArray] = useState([]);
  const [linkedTransactions, setLinkedTransactions] = useState<any[]>([]);
  const [isTransactionSelectorOpen, setIsTransactionSelectorOpen] = useState(false);
  const [isTradingPartnerSelectorOpen, setIsTradingPartnerSelectorOpen] = useState(false);

  // Trading Partner management state
  const [tradingPartnersData, setTradingPartnersData] = useState([]);
  const [isOpenTradingPartnerManager, setIsOpenTradingPartnerManager] = useState(false);
  const [clearingAccountsData, setClearingAccountsData] = useState([]);
  const [updateTradingPartnerData, setUpdateTradingPartnerData] = useState({
    _id: "",
    creditorNumber: "",
    debitorNumber: "",
    name: "",
    address: {
      street: "",
      zipCode: "",
      city: "",
      country: "Germany"
    },
    vatId: "",
    accountType: "TradingPartner" as 'TradingPartner' | 'Creditor' | 'Debitor' | 'Vendor' | 'Supplier' | 'Customer',
    openItemAccount: true,
    expenseAccount: "",
    bankDetails: {
      iban: "",
      bic: "",
      bankName: ""
    },
    paymentTerms: 30,
    email: "",
    phone: "",
    costCenter: "",
    department: ""
  });
  const [isInsertTradingPartner, setIsInsertTradingPartner] = useState(false);

  const api_url = process.env.NEXT_PUBLIC_API_URL
  const fileInputRef = useRef(null);


//MAP FOR TRAVEL EXPENSE
  const [startLocation, setStartLocation] = useState(null);
  const [endLocation, setEndLocation] = useState(null);
  const [map, setMap] = useState(null);

  
  React.useEffect(() => {
    let currentDate = new Date().toUTCString();
    let emptyInvoiceTemp = emptyInvoice;
    if(createInvoiceType == "travel-expense"){
      emptyInvoiceTemp.invoiceKind = "travel-expense";
      emptyInvoiceTemp.travelExpense = emptyTravelExpense;
      console.log("UPADET NEW INVOICE")
    }else{
      delete emptyInvoiceTemp.travelExpense;
    }
    setNewInvoice(emptyInvoiceTemp)

    // Set selectedDay based on invoice date or current date
    let dateToUse = currentDate;
    if (!createInvoice && rekeningData.length > 0 && selectedInvoice < rekeningData.length) {
      dateToUse = rekeningData[selectedInvoice].date;
    }

    setSelectedDay({
      year: new Date(dateToUse).getFullYear(),
      month: new Date(dateToUse).getMonth() + 1,
      day: new Date(dateToUse).getUTCDate(),
    })

    // Load trading partners when drawer opens
    if (invoiceIsOpen) {
      loadTradingPartners();
      loadClearingAccounts();
      // loadUnmatchedTransactions(); // No longer needed - TransactionSelectorDrawer handles this
    }
  }, [invoiceIsOpen, createInvoiceType])

  // Separate useEffect to update selectedDay when selectedInvoice changes
  React.useEffect(() => {
    if (!createInvoice && rekeningData.length > 0 && selectedInvoice < rekeningData.length) {
      const invoiceDate = new Date(rekeningData[selectedInvoice].date);
      setSelectedDay({
        year: invoiceDate.getFullYear(),
        month: invoiceDate.getMonth() + 1,
        day: invoiceDate.getUTCDate(),
      });
      
      const currentInvoice = rekeningData[selectedInvoice];
      if (currentInvoice?.linkedTransactions?.length > 0) {
        setLinkedTransactions(currentInvoice.linkedTransactions);
      } else {
        setLinkedTransactions([]);
      }
    }
  }, [selectedInvoice, rekeningData, createInvoice])

  React.useEffect(() => {
        if(bulkInsertData.length != 0){
            bulkInsert(bulkInsertData)
        }
  }, [bulkInsertData])

    const renderCustomInput = ({ ref }) => (
        <Input
          readOnly
          ref={ref} // necessary
          style={{
            width: "100%"
          }}
          placeholder="I'm a custom input"
          value={selectedDay ? `${selectedDay.day}.${selectedDay.month}.${selectedDay.year}` : ''}
        />
    )

    const closeInvoice = async ()=>{
        setCreateInvoice(true);
        setEditInvoiceErrorArray([]);
        setEditInvoiceModified(false);
        invoiceOnClose()
    }

  const deleteCurrentInvoice = async()=>{
    deleteInvoice(rekeningData[selectedInvoice]._id, false);
    setCreateInvoice(true);
    setSelectedInvoice(0);
    invoiceOnClose();
    setIsDeleteOpen(false);
    //calculateMonthlyCost()
    //setRekeningData([...rekeningDataTemp])
  }

  const deleteInvoice = async (id, bulkDelete) =>{

    const fetchData = await fetch(`${api_url}/invoices/${id}`, {
      method: "DELETE",
      headers: {
        'Authorization': `Bearer ${session.accessToken}`,
      },
    })
    let rekeningDataTemp = rekeningData.filter(e => e._id != id);
    if(!bulkDelete){
      setRekeningData(rekeningDataTemp);
    }
    setEditInvoiceModified(false)
    userNotification(t("invoiceDetails.deleteSuccessfull"), t("invoiceDetails.invDeletedSuccess"), "success");
    setChangedInvoices([])
  }
  const checkInvoiceDuplicate = async (scanAttachedMD5) =>{

    const fetchData = await fetch(`${api_url}/invoices/checkDuplicate?scanAttachedMD5=${scanAttachedMD5}`, {
      credentials: "include",
      method: "GET",
      headers: {
        'Authorization': `Bearer ${session.accessToken}`,
        'Content-Type': 'application/json'
      }
    })

    const fetchDataJson = await fetchData.json();

    console.log("RESPONSE: ",fetchDataJson);

    if("statusCode" in fetchDataJson && fetchDataJson["message"] == "Internal server error"){
      return []
    }else{
      return fetchDataJson;
    }
  }

  const createNewInvoice = async (data, bulkUpload = false) =>{
    let body = { ...data };


    if(data == undefined){
      return;
    }
    
    delete body.authorData;
    // Removed fields (legacy) - never send
    delete (body as any).debitAccount;
    delete (body as any).debitAccountSkr3;
    delete (body as any).creditorAccount;
    delete (body as any).creditorAccountSkr3;
    delete (body as any).bookingAccountSkr3;
    delete (body as any).bookingEntries;


    const fetchData = await fetch(`${api_url}/invoices`, {
      credentials: "include",
      method: "POST",
      headers: {
        'Authorization': `Bearer ${session.accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })

    const fetchDataJson = await fetchData.json();

    if("statusCode" in fetchDataJson && fetchDataJson["message"] == "Internal server error"){
      userNotification(t("invoiceDetails.errorCreateInv"), "error")
    }else if("statusCode" in fetchDataJson){
      console.log(fetchDataJson);
      userNotification("Creation Error", fetchDataJson["message"][0], "error");
      let errorTypes = []
      fetchDataJson["message"].map((singleError)=>{
        if(singleError == "invoiceType should not be empty"){
          errorTypes.push("invoiceType");
        }else if(singleError == "shop should not be empty"){
          errorTypes.push("shop");
        }else if(singleError == "taxPositions.0.value should not be empty" || singleError == "taxPositions.1.value should not be empty" || singleError == "taxPositions.2.value should not be empty" || singleError == "taxPositions.3.value should not be empty"){
          errorTypes.push("amount");
        }else if(singleError == "taxPositions.0.valueNet should not be empty" || singleError == "taxPositions.1.valueNet should not be empty" || singleError == "taxPositions.2.valueNet should not be empty" || singleError == "taxPositions.3.valueNet should not be empty"){
          errorTypes.push("amountNet");
        }else if(singleError == "taxPositions.0.taxRate should not be empty" || singleError == "taxPositions.1.taxRate should not be empty" || singleError == "taxPositions.2.taxRate should not be empty" || singleError == "taxPositions.3.taxRate should not be empty"){
          errorTypes.push("taxRate");
        }else if(singleError == "category should not be empty"){
          errorTypes.push("category");
        }else if(singleError == "travelExpense.locationFrom should not be empty"){
          errorTypes.push("locationFrom");
        }else if(singleError == "travelExpense.locationTo should not be empty"){
          errorTypes.push("locationTo");
        }else if(singleError == "travelExpense.transportationDistance should not be empty"){
          errorTypes.push("transportationDistance");
        }else if(singleError == "travelExpense.startDate must be a Date instance"){
          errorTypes.push("startDate");
        }else if(singleError == "travelExpense.endDate must be a Date instance"){
          errorTypes.push("endDate");
        }
      });
      setEditInvoiceErrorArray(errorTypes)
    }else{
      userNotification(t("invoiceDetails.createSucces"),t("invoiceDetails.invSuccessCreate"),"success");
      invoiceOnClose()
      setEditInvoiceErrorArray([]);
      await setNewInvoice(emptyInvoice);
      await setCreateInvoice(false);
    

      await setRekeningData([]);
      await loadInvoices()
      if(!bulkUpload  && "statusCode" in fetchDataJson == false){
        setChangedInvoices([fetchDataJson._id]);
        setTimeout(()=>{
          scroller.scrollTo(fetchDataJson._id, {
            duration: 500,
            delay: 0,
            smooth: true,
            offset: -100, // Scrolls to element + 50 pixels down the page
          })
        },200)
      }
    }
    return fetchDataJson;
  }


  const saveInvoiceData = async(openInvoiceData)=>{
    setEditInvoiceModified(true);
    if(createInvoice == true){
      setNewInvoice({...openInvoiceData})
    }else{

      const rekeningDataTemp = rekeningData;
      rekeningDataTemp[selectedInvoice] = openInvoiceData;
      setRekeningData([...rekeningDataTemp]);
    }
  }

  const updateInvoice = async (data) =>{
    let body = { ...data }
    // Removed fields (legacy) - never send
    delete (body as any).debitAccount;
    delete (body as any).debitAccountSkr3;
    delete (body as any).creditorAccount;
    delete (body as any).creditorAccountSkr3;
    delete (body as any).bookingAccountSkr3;
    delete (body as any).bookingEntries;
    delete (body as any).linkedTransactionId;
    delete (body as any).linkedTransactions;
    delete (body as any).linkedTransactionCount;
    delete (body as any).linkedTransactionAmountSum;
    delete (body as any).remainingAmount;

    if(data == undefined){
      return;
    }

    const fetchData = await fetch(`${api_url}/invoices/${data._id}`, {
      method: "PATCH",
      headers: {
        'Authorization': `Bearer ${session.accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
    const fetchDataJson = await fetchData.json();
    if("statusCode" in fetchDataJson){
      userNotification(t("invoiceDetails.updateError"), fetchDataJson["message"][0], "error");

      let errorTypes = []
      fetchDataJson["message"].map((singleError)=>{
        if(singleError == "invoiceType should not be empty"){
          errorTypes.push("invoiceType");
        }else if(singleError == "shop should not be empty"){
          errorTypes.push("shop");
        }else if(singleError == "taxPositions.0.value should not be empty" || singleError == "taxPositions.1.value should not be empty" || singleError == "taxPositions.2.value should not be empty" || singleError == "taxPositions.3.value should not be empty"){
          errorTypes.push("amount");
        }else if(singleError == "taxPositions.0.valueNet should not be empty" || singleError == "taxPositions.1.valueNet should not be empty" || singleError == "taxPositions.2.valueNet should not be empty" || singleError == "taxPositions.3.valueNet should not be empty"){
          errorTypes.push("amountNet");
        }else if(singleError == "taxPositions.0.taxRate should not be empty" || singleError == "taxPositions.1.taxRate should not be empty" || singleError == "taxPositions.2.taxRate should not be empty" || singleError == "taxPositions.3.taxRate should not be empty"){
          errorTypes.push("taxRate");
        }else if(singleError == "category should not be empty"){
          errorTypes.push("category");
        }
      });
      setEditInvoiceErrorArray(errorTypes)
      return false;
    }else{
      userNotification(t("invoiceDetails.updateSuccess"), t("invoiceDetails.invUpdateSuccessfully"), "success");
      setChangedInvoices([fetchDataJson["_id"]]);
      closeInvoice()

      setEditInvoiceModified(false);
      setEditInvoiceErrorArray([]);

      await loadSingleInvoices(data._id)
      return true;
    }
    
  }
  
  const loadTradingPartners = async () => {
    try {
      const fetchData = await axios.get(`${api_url}/trading-partners`, { 
        headers: { Authorization: `Bearer ${session.accessToken}` }
      });
      const data = await fetchData;

      if(data.status != 403 && data.status != 500){
        setTradingPartnersData(data.data.tradingPartners || data.data);
        return data.data.tradingPartners || data.data; 
      }
    }catch (ex){
      return
    }
  }

  const loadClearingAccounts = async () => {
    try {
      const fetchData = await axios.get(`${api_url}/clearing-accounts`, { 
        headers: { Authorization: `Bearer ${session.accessToken}` }
      });
      const data = await fetchData;

      if(data.status != 403 && data.status != 500){
        setClearingAccountsData(data.data);
        return data.data; 
      }
    }catch (ex){
      return
    }
  }

  const openTradingPartnerManager = async (tradingPartner) => {
    await setUpdateTradingPartnerData({
      _id: tradingPartner._id,
      creditorNumber: tradingPartner.creditorNumber,
      debitorNumber: tradingPartner.debitorNumber || "",
      name: tradingPartner.name,
      address: tradingPartner.address || {
        street: "",
        zipCode: "",
        city: "",
        country: "Germany"
      },
      vatId: tradingPartner.vatId || "",
      accountType: tradingPartner.accountType,
      openItemAccount: tradingPartner.openItemAccount,
      expenseAccount: tradingPartner.expenseAccount || "",
      bankDetails: tradingPartner.bankDetails || { iban: "", bic: "", bankName: "" },
      paymentTerms: tradingPartner.paymentTerms || 30,
      email: tradingPartner.email || "",
      phone: tradingPartner.phone || "",
      costCenter: tradingPartner.costCenter || "",
      department: tradingPartner.department || ""
    } as any);
    await setIsInsertTradingPartner(false);
    setIsOpenTradingPartnerManager(true);
  }

  const openCreateTradingPartner = async () => {
    await setUpdateTradingPartnerData({
      _id: "",
      creditorNumber: "",
      debitorNumber: "",
      name: "",
      address: {
        street: "",
        zipCode: "",
        city: "",
        country: "Germany"
      },
      vatId: "",
      accountType: "TradingPartner",
      openItemAccount: true,
      expenseAccount: "",
      bankDetails: {
        iban: "",
        bic: "",
        bankName: ""
      },
      paymentTerms: 30,
      email: "",
      phone: "",
      costCenter: "",
      department: ""
    });
    await setIsInsertTradingPartner(true);
    setIsOpenTradingPartnerManager(true);
  }
  
  const onChangeTextOpenInvoice = (key, val) => {
    
    let openInvoiceData = newInvoice;
    if(createInvoice == false){
      openInvoiceData = rekeningData[selectedInvoice];
    }
    if(key == "total"){
      val = val.replace(",",".");
    }
    if(key == "mwst"){
      if(val <= 0){
        val = 0;
      }if(val >= 100){
        val = 100;
      }
    }
    openInvoiceData[key] = val;

    if (key === "linkedTransactionIds") {
      if (!val || (Array.isArray(val) && val.length === 0)) {
        setLinkedTransactions([]);
        (openInvoiceData as any).link = null;
      }
    }

    if(key == "total" || key == "mwst"){
      let vat;
      let total = Number(openInvoiceData.total);
      vat = total * (1 - parseInt(openInvoiceData.mwst) / 100);
      vat = vat.toFixed(2);
      openInvoiceData.tax = vat;
    }
    if(key == "category"){
      loadBudgetSpending(val);
    }
    
    if(key == "invoiceType"){
      
      let invTypeTemp = invoiceTypesData.find(e=> e._id == val);
      
      openInvoiceData["invoiceStatus"] = invTypeTemp.steps[0]._id;
    }

    //SAVE
    saveInvoiceData(openInvoiceData);
  }


  const editInvoiceStatusUpdate = async (update) =>{
    let invoiceTypeStatusIndex,
    invoiceTypeTemp;

    invoiceTypeTemp = invoiceTypesData.find(e => e._id == editInvoice.invoiceType);

    if(invoiceTypeTemp != undefined){
      invoiceTypeStatusIndex = invoiceTypeTemp.steps.findIndex(e => e._id == editInvoice.invoiceStatus);
    }
    if(invoiceTypeTemp == undefined || invoiceTypeStatusIndex == undefined){
      return;
    }
    if(update == "approve" && invoiceTypeStatusIndex < invoiceTypeTemp.steps.length - 1){
      onChangeTextOpenInvoice("invoiceStatus" ,invoiceTypeTemp.steps[invoiceTypeStatusIndex+1]._id);
    }else if(update == "reject" && invoiceTypeStatusIndex > 0 ){
      onChangeTextOpenInvoice("invoiceStatus" ,invoiceTypeTemp.steps[invoiceTypeStatusIndex -1]._id);
    }
    saveInvoice()
  }

  const calculateTravelExpenseCost = async (body) => {
    let travelExpenseTemp = editInvoice.travelExpense;
   
    if(
      travelExpenseTemp["title"] == "" ||
      travelExpenseTemp["allowanceBig"] == "" ||
      travelExpenseTemp["allowanceSmall"] == "" ||
      travelExpenseTemp["breakfasts"] == "" ||
      travelExpenseTemp["lunches"] == "" ||
      travelExpenseTemp["dinners"] == "" ||
      travelExpenseTemp["startDate"] == "" ||
      travelExpenseTemp["endDate"] == ""||
      travelExpenseTemp["description"] == ""||
      travelExpenseTemp["locationTo"] == ""||
      travelExpenseTemp["transportationDistance"] == ""
    ){
      return;
    }
    const fetchData = await fetch(`${api_url}/travelExpense/calculate`, {
      credentials: "include",
      method: "POST",
      headers: {
        'Authorization': `Bearer ${session.accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })

    const fetchDataJson = await fetchData.json();

    if("statusCode" in fetchDataJson){
      //userNotification("Creation Error", fetchDataJson["message"][0], "error");
    }else{
      travelExpenseTemp["compensation"] = fetchDataJson.cost;
      let tempInvoiceData = editInvoice;
      tempInvoiceData.travelExpense = travelExpenseTemp;
      saveInvoiceData(tempInvoiceData)

      //userNotification("New Travel Expense Created","Your new travel expense has been successfully created","success");
      //onTravelExpenseClose()
    }
  }

  const changeTravelExpenseLocation = async(key, value)=>{
    console.log("UPDATE TRAVEL", key, value);

    let location = value.label;
    let locationPlaceId = value.value.place_id;
    await onChangeTextTravelExpense(key, location);
    await onChangeTextTravelExpense(key+"PlaceId", locationPlaceId);
    
    if(key == "locationTo"){
      let country = value.value.terms;
      await onChangeTextTravelExpense("country", country);
    }

    let locationFrom = editInvoice.travelExpense["locationFrom"],
    locationTo = editInvoice.travelExpense["locationTo"];
    console.log("UPDATE LOCATION.")
    if(locationFrom != "" && locationTo != ""){
      console.log("Check Distance");
      let distance = await updateDistance(locationFrom, locationTo);
      onChangeTextTravelExpense("transportationDistance", distance);
    }

    /*

    MAP Visualization for travel not working

    const { lat, lng } = value.value.geometry.location;
    const selectedLocation = { lat: lat(), lng: lng() };

    if (key === "locationFrom") {
      setStartLocation(selectedLocation);
    } else if (key === "locationTo") {
      setEndLocation(selectedLocation);
    }*/
  }
  /*
  useEffect(() => {
    if (map && startLocation && endLocation) {
      const bounds = {
        north: Math.max(startLocation.lat, endLocation.lat),
        south: Math.min(startLocation.lat, endLocation.lat),
        east: Math.max(startLocation.lng, endLocation.lng),
        west: Math.min(startLocation.lng, endLocation.lng),
      };
      map.fitBounds(bounds);
    }
  }, [startLocation, endLocation, map]);*/

  const onChangeTextTravelExpense = async (key, value) =>{

      let invoiceDataTemp = editInvoice;
      

      if(key == "country"){
        let country = value.pop().value;
        let region = value.length != 0 && value.pop().value;
        let city = value.length != 0 && value.pop().value;


        let countryAllowance = undefined;        
        
        //Check for country + region
        countryAllowance = countryListAllowance.find(e => e.name == country +" - "+region);
        
        //Check for country + city
        if(countryAllowance == undefined){
          countryAllowance = countryListAllowance.find(e => e.name == country +" - "+city);
        }

        //Check just for country
        if(countryAllowance == undefined){
          countryAllowance = countryListAllowance.find(e => e.name == country);
        }

        if(countryAllowance == undefined){
          invoiceDataTemp.travelExpense["allowanceSmall"] = "";
          invoiceDataTemp.travelExpense["allowanceBig"] = "";
          invoiceDataTemp.travelExpense[key] = value;
        }else{
          invoiceDataTemp.travelExpense["allowanceSmall"] = countryAllowance.small.toString();
          invoiceDataTemp.travelExpense["allowanceBig"] = countryAllowance.large.toString();
          invoiceDataTemp.travelExpense[key] = countryAllowance.code;
        }
      }else{

        invoiceDataTemp.travelExpense[key] = value;
      }
      try {
        updateMeals(0, "breakfast", editInvoice.travelExpense["meals"][0]["breakfast"]) 
      } catch (error) {
        console.log(error)
      }

      saveInvoiceData(invoiceDataTemp)
      //calculateTravelExpenseCost(invoiceDataTemp.travelExpense)
  }

  const updateDistance = async(origin, destination)=>{
    const apiKey = 'AIzaSyAAmYYPOLxV94MyxnuATvQj93Y0Lik0FwE';

    const url = `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${origin}&destinations=${destination}&key=${apiKey}`;

    try {
      const response = await axios.get(url);
      const result = response.data;
      const distanceInMeters = (result.rows[0].elements[0].distance.value / 1000).toFixed(0);
      return distanceInMeters
    } catch (error) {
      return 0
      console.error('Error fetching data: ', error);
    }
  }
  
  const updateMeals = async (index, mealType, value)=>{
    
    let invoiceDataTemp = editInvoice;
    
    invoiceDataTemp.travelExpense["meals"][index][mealType] = value;

    let totalAllowance = 0,
    allowanceBig = invoiceDataTemp.travelExpense["allowanceBig"],
    allowanceSmall = invoiceDataTemp.travelExpense["allowanceSmall"];

    invoiceDataTemp.travelExpense["meals"].map((singleMeal, dayIndex)=>{
      
      let deductionBreakfast = parseFloat(allowanceBig)*0.2;
      let deductionLunch = parseFloat(allowanceBig)*0.4;
      let deductionDinner = parseFloat(allowanceBig)*0.4;
      let allowance = parseFloat(allowanceBig)
                
      if(dayIndex == 0 || dayIndex == invoiceDataTemp.travelExpense["meals"].length - 1){
        allowance = parseFloat(allowanceSmall)
      }

      if(singleMeal.breakfast == false){
        deductionBreakfast = 0;
      }
      if(singleMeal.lunch == false){
        deductionLunch = 0;
      }
      if(singleMeal.dinner == false){
        deductionDinner = 0;
      }

      totalAllowance += Math.max(allowance - deductionBreakfast - deductionLunch - deductionDinner, 0);
    })
    console.log("TOTAL:", totalAllowance.toFixed(2));
    console.log("TOTAL:",invoiceDataTemp);
    saveInvoiceData(invoiceDataTemp)
    await onChangeTotalOpenInvoice("taxRate", "0", 0);
    await onChangeTotalOpenInvoice("value", totalAllowance, 0);

  }

  const onChangeTotalOpenInvoice = (key, val, ind)=>{


    let openInvoiceData = newInvoice;
    if(createInvoice == false){
      openInvoiceData = rekeningData[selectedInvoice];
    }


    let tax = parseFloat("0.0"),
    total = parseFloat("0.0"),
    totalNet = parseFloat("0.0");
    

    console.log("VAL: ", val)
    openInvoiceData.taxPositions[ind][key] = val;

    let indValue = openInvoiceData.taxPositions[ind]["value"],
    indValueNet = openInvoiceData.taxPositions[ind]["valueNet"],
    indTaxRate = openInvoiceData.taxPositions[ind]["taxRate"];


    openInvoiceData.taxPositions.map((singlePosition, i)=>{

      if(key == "value"){
        if(i == ind && indValue != "" && indTaxRate != ""){
          
          openInvoiceData.taxPositions[ind]["valueNet"] = (parseFloat(indValue) / (1 + parseInt(indTaxRate) / 100)).toFixed(2).toString();
      
          /*openInvoiceData.taxPositions[ind]["value"] = indValue;
          openInvoiceData.taxPositions[ind]["taxRate"] = (1 - (parseFloat(indValue) / parseFloat(indValueNet)) * 100).toFixed(0).toString();
          */
        }
      }

      if(key == "valueNet"){
        if(i == ind){
          indValueNet = val;
        }
      }

      if(key == "valueTax"){
        if(i == ind){
          // valueTax can be empty or a number, just store it
          openInvoiceData.taxPositions[ind]["valueTax"] = val != null ? val.toString() : "";
        }
      }

      if(key == "taxRate"){
        if(val <= 0){
          val = 0;
        }if(val >= 100){
          val = 100;
        }
        if(i == ind){
          indTaxRate = val;
        }
      }
      
      total += Number(singlePosition.value);
      /*totalNet += parseFloat(singlePosition.value) / (1 + parseInt(singlePosition.taxRate) / 100);
      tax += parseFloat(singlePosition.value) - (parseFloat(singlePosition.value) / (1 + parseInt(singlePosition.taxRate) / 100));
      */
      totalNet += parseFloat(singlePosition.valueNet);
      tax += (parseFloat(singlePosition.value) - parseFloat(singlePosition.valueNet));
    })

    

    openInvoiceData.total = total.toFixed(2).toString();
    openInvoiceData.tax = tax.toFixed(2).toString();
    openInvoiceData.totalNet = totalNet.toFixed(2).toString();
    //SAVE
    saveInvoiceData(openInvoiceData);
  }
  
  const editInvoiceAddTaxRate = async()=>{
    let openInvoiceData = newInvoice;
    if(createInvoice == false){
      openInvoiceData = rekeningData[selectedInvoice];
    }
    
    if(openInvoiceData.taxPositions == undefined){
      openInvoiceData.taxPositions = [];
      let tempDataPosition = {
        taxRate: openInvoiceData.mwst,
        value: openInvoiceData.total,
        valueNet: openInvoiceData.totalNet,
        valueTax: ""
      }
      openInvoiceData.taxPositions.push(tempDataPosition);
    }

    openInvoiceData.taxPositions.push({taxRate: "0", value: "", valueNet: "", valueTax: ""} as any)

    saveInvoiceData(openInvoiceData);
  }
  const editInvoiceRemoveTaxRate = async (index)=>{
    let openInvoiceData = newInvoice;
    if(createInvoice == false){
      openInvoiceData = rekeningData[selectedInvoice];
    }
    
    openInvoiceData.taxPositions.splice(index, 1);

    saveInvoiceData(openInvoiceData);

  }

  const editInvoiceAddBookingEntry = async () => {
    let openInvoiceData = newInvoice;
    if (createInvoice == false) {
      openInvoiceData = rekeningData[selectedInvoice];
    }

    if (!Array.isArray((openInvoiceData as any).bookingRecords)) {
      (openInvoiceData as any).bookingRecords = [];
    }

    const defaults: BookingEntry = {
      amount: "",
      baseAmount: "",
      account: "",
      buSchluessel: "",
      documentField1: (openInvoiceData as any).invoiceNumber || "",
      documentField2: "",
      bookingText: (openInvoiceData as any).shop || "",
      euTaxRate: "",
      taxRate: (openInvoiceData as any).mwst || "",
      performanceDate: "",
      dueDate: "",
    };

    (openInvoiceData as any).bookingRecords.push(defaults);
    saveInvoiceData(openInvoiceData);
  };

  const editInvoiceRemoveBookingEntry = async (index) => {
    let openInvoiceData = newInvoice;
    if (createInvoice == false) {
      openInvoiceData = rekeningData[selectedInvoice];
    }
    if (!Array.isArray((openInvoiceData as any).bookingRecords)) {
      (openInvoiceData as any).bookingRecords = [];
    }
    (openInvoiceData as any).bookingRecords.splice(index, 1);
    saveInvoiceData(openInvoiceData);
  };

  const onChangeBookingEntry = (index: number, key: keyof BookingEntry, val: any) => {
    let openInvoiceData = newInvoice;
    if (createInvoice == false) {
      openInvoiceData = rekeningData[selectedInvoice];
    }
    if (!Array.isArray((openInvoiceData as any).bookingRecords)) {
      (openInvoiceData as any).bookingRecords = [];
    }
    if (!(openInvoiceData as any).bookingRecords[index]) {
      (openInvoiceData as any).bookingRecords[index] = {};
    }

    (openInvoiceData as any).bookingRecords[index][key] = val;
    saveInvoiceData(openInvoiceData);
  };

  const removeImageFromInvoice = async () =>{
    let openInvoiceData = newInvoice;
    if(createInvoice == false){
      openInvoiceData = rekeningData[selectedInvoice];
    }
    
    openInvoiceData.scanAttached = "";
    openInvoiceData.scanAttachedMD5 = "";
    
    saveInvoiceData(openInvoiceData);


  }

  const changeInvoiceDate = async(newDate)=>{
    setSelectedDay(newDate);
    const invoiceDate = new Date(newDate.year, newDate.month -1, newDate.day);
    invoiceDate.setHours(12);
    let openInvoiceData = newInvoice;
    if(createInvoice == false){
      openInvoiceData = rekeningData[selectedInvoice];
    }
    openInvoiceData.date = invoiceDate.toUTCString();
    saveInvoiceData(openInvoiceData);
  }
  const refund = async (status) =>{
    let openInvoiceData = newInvoice;
    if(createInvoice == false){
      openInvoiceData = rekeningData[selectedInvoice];
    }
    openInvoiceData.status = status;

    saveInvoiceData(openInvoiceData);
  }


  const saveInvoice = async()=>{
    setSaveInvoiceLoading(true);
    console.log("NEW INVOICE Data:", newInvoice)
    let openInvoiceData = newInvoice;
    if(createInvoice == false && !editInvoiceReadonly){
      openInvoiceData = rekeningData[selectedInvoice];
      await updateInvoice(openInvoiceData)
    }else if(createInvoice == true){
      await createNewInvoice(openInvoiceData)
    }else{
      userNotification("Saving not possible",editInvoiceReadonlyReason,"error");
    }
    //setRekeningDataOriginal([...rekeningData])

    setSaveInvoiceLoading(false)
  }

  const removeProduct = async(index)=>{
    let openInvoiceData = newInvoice;
    if(createInvoice == false){
      openInvoiceData = rekeningData[selectedInvoice];
    }
    openInvoiceData.items.splice(index, 1);
    saveInvoiceData(openInvoiceData);
  }



  //Bulk Upload:

  const uploadFile = async(data, returnOnlyData = false, aiDisabled = false) =>{
    
    console.log("AI DISABLED");
    if(returnOnlyData == false){
      setUploadInProgress(true)
    }
    var formData = new FormData();
    formData.append('file', data)
    const fetchData = await fetch(withInvoiceQueueConsumerTarget(`${api_url}/files/upload/?disableAi=${aiDisabled}&useOpenAI=true`), {
      headers: {
        'Authorization': `Bearer ${session.accessToken}`,
      },
      credentials: "include",
      method: "Post",
      body: formData
    })
    const response = await fetchData.json();
    console.log(response);
    if(response.statusCode == 400 || response.statusCode == 500){
      userNotification(t("invoiceDetails.processingError"), t("invoiceDetails.processingErrorDetails"), "error")
      setUploadInProgress(false);
      return;
    }
    if(returnOnlyData == true){
      return response;
    }
    if("data" in response){
      let invoiceData = rekeningData[selectedInvoice];
      invoiceData.scanAttached = response.imageUrl;
      saveInvoiceData(invoiceData);
    }else{
      onChangeTextOpenInvoice("scanAttached",response.imageUrl);
      onChangeTextOpenInvoice("scanAttachedMD5",response.scanAttachedMD5);
    }
    setUploadInProgress(false)
    
  }

  const bulkInsert = async (acceptedFiles) => {
    let counter = 0;
    let newInvoiceIds = [];
    setBulkUploadCounterFinished(0);
    for (const file of acceptedFiles) {
        console.log("FILE:", file);
        let uploadData = await uploadFile(file, true);
        console.log("UPLOAD DATA:", uploadData)
        if (uploadData != undefined && "data" in uploadData) {
            console.log("Upload Data:", uploadData);
            let checkDuplicate = await checkInvoiceDuplicate(uploadData.scanAttachedMD5);
            
            console.log("DUPLICATE CHEHCK", checkDuplicate);

            if (checkDuplicate != undefined && checkDuplicate.length != 0) {
                console.log("DUPLICATE", checkDuplicate)
                // Show the modal and wait for the user's decision
                setDuplicateCurrentFile(file);
                setIsDuplicateModalOpen(true);

                // Wait for user's decision
                const decision = await new Promise((resolve) => {
                    const handleDecision = (decision) => {
                        setIsDuplicateModalOpen(false);
                        resolve(decision);
                    };
                    setDuplicateUserDecision(() => handleDecision);
                });

                if (decision === 'skip') {
                    counter++;
                    setBulkUploadCounterFinished(counter);
                    continue;
                }
            }
            
            // Only assign category if it's selected, otherwise let AI analysis determine it
            if (bulkUploadSettings.category) {
              uploadData.data.category = bulkUploadSettings.category;
            }
            uploadData.data.invoiceType = bulkUploadSettings.invoiceType;
            uploadData.data.invoiceStatus = invoiceTypesData.find(e => e._id == bulkUploadSettings.invoiceType).steps[0]._id;
            
            let creatInvoice = await createNewInvoice(uploadData.data, true);

            newInvoiceIds.push(creatInvoice["_id"]);
            counter++;
            setBulkUploadCounterFinished(counter);
        } else {
            counter++;
            setBulkUploadCounterFinished(counter);
            userNotification(t("invoiceDetails.uploadError"), t("invoiceDetails.uploadErrorDetails"), "error");
        }
    }
    setChangedInvoices(newInvoiceIds);
    setBulkInsertData([]);
  }


/*
  const bulkInsert = async (acceptedFiles) =>{
    let counter = 0;
    let newInvoiceIds = []
    setBulkUploadCounterFinished(0);
    for (const file of acceptedFiles) {
      console.log("FILE:", file);
        let uploadData = await uploadFile(file, true);
        if("data" in uploadData){
          console.log("Upload DAta:", uploadData);
          let checkDuplicate = await checkInvoiceDuplicate(uploadData.scanAttachedMD5);
          
          if(checkDuplicate != undefined && checkDuplicate.length != 0){
            //show 2 buttons in Frontend and wait fpr decision
          }
          
          uploadData.data.category = bulkUploadSettings.category;
          uploadData.data.invoiceType = bulkUploadSettings.invoiceType;
          uploadData.data.invoiceStatus = invoiceTypesData.find(e => e._id == bulkUploadSettings.invoiceType).steps[0]._id;
          
          let creatInvoice = await createNewInvoice(uploadData.data, true);

          newInvoiceIds.push(creatInvoice["_id"])
          counter = counter + 1;
          setBulkUploadCounterFinished(counter);
        }else{
          counter = counter + 1;
          setBulkUploadCounterFinished(counter);
          userNotification("Upload Error","One document could not be imported", "error")
        }
    }
    setChangedInvoices(newInvoiceIds);
    setBulkInsertData([])
  }*/

  const printTravelExpense = (id)=>{
    window.open("/travelExpensePrint/"+id, "_blank").focus()
  }


  let invoiceTypeNextStepAllowed = false;
  let invoiceTypeBackStepAllowed = false;

    //Data for drawer
    let editInvoice = newInvoice;
    if((createInvoice == true || rekeningData.length == 0)){
        editInvoice = newInvoice;
    }else{
        editInvoice = rekeningData[selectedInvoice];
    }
    // Guard against transient undefined (e.g. index out of bounds while list refreshes)
    if (!editInvoice) {
      editInvoice = newInvoice || emptyInvoice;
    }

    const bookingValidationActive = editInvoice?.invoiceKind !== "travel-expense";
    const bookingEntries: BookingEntry[] = Array.isArray((editInvoice as any)?.bookingRecords)
      ? ((editInvoice as any).bookingRecords as BookingEntry[])
      : Array.isArray((editInvoice as any)?.bookingEntries)
        ? ((editInvoice as any).bookingEntries as BookingEntry[])
        : [];
    const invoiceTotalCents = toCents((editInvoice as any)?.total);
    const bookingEntriesSumCents = bookingEntries.reduce((sum, e) => sum + toCents(e?.amount), 0);
    const bookingEntriesSumValid =
      !bookingValidationActive ? true : bookingEntries.length > 0 && bookingEntriesSumCents === invoiceTotalCents;

    // Prefer signed URL from the invoice list for any preview/open of attachments.
    // Fallback to the legacy `scanAttached` field when the signed URL isn't present.
    const attachmentUrl =
      (editInvoice as any)?.scanAttachedSignedUrl || (editInvoice as any)?.scanAttached || "";

    // When the PDF preview is open, prevent background (body) scrolling.
    // Otherwise wheel events over the embedded <object> can scroll the underlying page.
    const isPdfPreviewOpen =
      invoiceIsOpen === true &&
      typeof attachmentUrl === "string" &&
      attachmentUrl !== "" &&
      (() => {
        try {
          return new URL(attachmentUrl).pathname.toLowerCase().endsWith(".pdf");
        } catch {
          return attachmentUrl.split("?")[0].toLowerCase().endsWith(".pdf");
        }
      })();

    useEffect(() => {
      if (!isPdfPreviewOpen) return;
      const prevBodyOverflow = document.body.style.overflow;
      const prevHtmlOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prevBodyOverflow;
        document.documentElement.style.overflow = prevHtmlOverflow;
      };
    }, [isPdfPreviewOpen]);

    try {
        const invoiceTypeTemp = invoiceTypesData.find(e => e._id == editInvoice.invoiceType);
        if(invoiceTypeTemp != undefined){
          const invoiceTypeStatus = invoiceTypeTemp.steps.find(e => e._id == editInvoice.invoiceStatus);
          const invoiceTypeStatusIndex = invoiceTypeTemp.steps.findIndex(e => e._id == editInvoice.invoiceStatus);
    
          // Check if approval exists and user_data.groups exists before accessing
          const userGroups = session?.user_data?.groups;
          const approvalArray = invoiceTypeStatus?.approval || [];
          console.log("USER Data:", session?.user_data)
          console.log("APPROVAL ARRAY:", approvalArray)
          
          // If no approval groups are defined, allow access
          // If approval groups exist, check if user is in one of them
          let invoiceTypeStepApproval = false;
          if (approvalArray.length === 0) {
            // No approval required
            invoiceTypeStepApproval = true;
          } else if (userGroups && Array.isArray(userGroups)) {
            // Check if user is in any of the approval groups
            invoiceTypeStepApproval = approvalArray.some(item => userGroups.includes(item));
          }
          // If userGroups is undefined/null and approval groups exist, deny access
          console.log("INVOICE TYPE STEP APPROVAL:", invoiceTypeStepApproval)

          invoiceTypeNextStepAllowed = (invoiceTypeStepApproval && invoiceTypeStatusIndex < invoiceTypeTemp.steps.length -1)
          invoiceTypeBackStepAllowed = (invoiceTypeStepApproval && invoiceTypeStatusIndex > 0);
        }else{
          invoiceTypeNextStepAllowed = true;
        }
      } catch (error) {
        console.log(error)
      }

      const currencyInputConfig = {"locale":"de","currency":(editInvoice as any)?.currency || "EUR"};

    const deleteInvoiceHeaderLabel =
      editInvoice?.invoiceKind == "travel-expense"
        ? t("invoiceDetails.deleteTravelExpense")
        : t("invoiceDetails.deleteInvoice");

  const modalContent = invoiceIsOpen ? (
    <div>
    <Drawer
    isOpen={invoiceIsOpen}
    placement='right'
    size="lg"
    // Don't lock page scroll; otherwise embedded PDF preview (outside DrawerContent) may not receive wheel events reliably.
    blockScrollOnMount={false}
    onClose={()=>{
      console.log("editInvoiceModified",editInvoiceModified)
      console.log("invoiceTypeNextStepAllowed",invoiceTypeNextStepAllowed)
      console.log("newInvoice",newInvoice)
      if(editInvoiceModified == true && invoiceTypeNextStepAllowed && !createInvoice){
        onCloseEditWithoutSaveOpen()
      }else{
        closeInvoice()
      }
    }}
  >
    {/* Ensure the grey overlay sits above the fixed side-menu (z-index 1000). */}
    <DrawerOverlay zIndex={1200} />
    <DrawerContent zIndex={1250}>
      {/* Close button: visible, secondary/outline style, and above sticky header */}
      <DrawerCloseButton
        zIndex={3}
        top="12px"
        right="12px"
        size="sm"
        variant="outline"
        colorScheme="rekening"
        bg="white"
      />
      <DrawerHeader
        position="sticky"
        top={0}
        zIndex={2}
        bg="white"
        borderBottom="1px solid"
        borderColor="gray.200"
        pr="64px"
      >
        <Flex gap={3} align="center">
          <HStack spacing="6px">
            {("authorData" in editInvoice &&
              editInvoice.authorData.length != 0 &&
              ("profilePicture" in editInvoice.authorData[0] == false ||
                editInvoice.authorData[0]["profilePicture"] == "")) && (
              <Avatar
                marginRight={2}
                borderRadius={10}
                height={45}
                width={45}
                className="rekening-invoice-avatar"
                name={editInvoice["authorData"][0]["username"]}
              />
            )}
            {("authorData" in editInvoice &&
              editInvoice.authorData.length != 0 &&
              "profilePicture" in editInvoice.authorData[0] &&
              editInvoice.authorData[0]["profilePicture"] != "") && (
              <Avatar
                marginRight={2}
                borderRadius={10}
                height={45}
                width={45}
                className="rekening-invoice-avatar"
                src={String(
                  editInvoice["authorData"]?.[0]?.["profilePictureSignedUrl"] ||
                    editInvoice["authorData"]?.[0]?.["profilePicture"] ||
                    ""
                )}
              />
            )}
            {("authorData" in editInvoice && editInvoice.authorData.length == 0) && (
              <Avatar
                marginRight={2}
                borderRadius={10}
                height={45}
                width={45}
                className="rekening-invoice-avatar"
                name={""}
              />
            )}
            <div className="rekening-invoice-icon">
              <IoBriefcase fontSize={"35px"}></IoBriefcase>
            </div>
          </HStack>

          <Box flex="1" minW={0}>
            <HStack spacing={2}>
              <Heading as="h4" size="md" noOfLines={1}>
                {editInvoice.shop}
              </Heading>
              <Badge colorScheme="gray" variant="subtle">
                {editInvoice.invoiceKind == "travel-expense"
                  ? t("invoiceDetails.travelExpense")
                  : t("invoiceDetails.invoice")}
              </Badge>
            </HStack>
            <Text color="gray.500" fontWeight="semibold" fontSize="sm">
              {new Date(editInvoice.date).toLocaleDateString()}
            </Text>
          </Box>

          <Box textAlign="right" minW={0}>
            <Heading as="h4" size="md">
              {editInvoice.total} {editInvoice.currency}
            </Heading>
            <Text color="gray.500" fontWeight="semibold" fontSize="sm">
              {editInvoice.totalNet} ({editInvoice.tax}) {editInvoice.currency}
            </Text>
          </Box>
        </Flex>
      </DrawerHeader>

      <DeleteModal
        isOpen={isDeleteOpen}
        onCancel={() => setIsDeleteOpen(false)}
        onConfirm={deleteCurrentInvoice}
        headerMessage={
          editInvoice.invoiceKind == "travel-expense"
            ? t("invoiceDetails.deleteTravelExpense")
            : t("invoiceDetails.deleteInvoice")
        }
        bodyMessage={t("invoiceDetails.sureToDelete")}
        details={{
          title: t("deleteModalElement.detailsTitle"),
          items: [
            {
              label: t("invoiceDetails.name"),
              value: editInvoice.shop || "-",
            },
            {
              label: t("invoiceDetails.date"),
              value: new Date(editInvoice.date).toLocaleDateString("de-DE"),
            },
            {
              label: t("invoiceDetails.totalAmount"),
              value: `${editInvoice.total} ${editInvoice.currency}`,
            },
          ],
        }}
      ></DeleteModal>

      <DrawerBody>
        <VStack spacing={5} align="stretch" mt={4}>
          {invoiceTypeNextStepAllowed == false && createInvoice == false && (
            <Alert status="warning" borderRadius="md">
              <AlertIcon />
              <Box>
                <Text fontWeight="bold">{t("invoiceDetails.readonlyTitle")}</Text>
                <Text fontSize="sm" color="gray.700">
                  {t("invoiceDetails.readonlyDescription")}
                </Text>
              </Box>
            </Alert>
          )}

          <Box
            bg="gray.100"
            p={1}
            borderRadius="lg"
            display="inline-flex"
            mb={4}
            flexWrap="wrap"
            gap={1}
          >
            <Button
              size="sm"
              h="32px"
              px={3}
              borderRadius="md"
              fontWeight={drawerMainTab === "settings" ? "600" : "500"}
              bg={drawerMainTab === "settings" ? "white" : "transparent"}
              boxShadow={drawerMainTab === "settings" ? "sm" : "none"}
              color={drawerMainTab === "settings" ? "gray.800" : "gray.600"}
              _hover={
                drawerMainTab !== "settings"
                  ? { bg: "white", boxShadow: "sm", color: "gray.800" }
                  : {}
              }
              onClick={() => setDrawerMainTab("settings")}
              leftIcon={
                <Icon
                  as={IoSettingsOutline}
                  boxSize={3.5}
                  color={drawerMainTab === "settings" ? "rekening.600" : "gray.500"}
                />
              }
              transition="all 0.15s ease"
            >
              {t("invoiceDetails.drawerTabSettings")}
            </Button>
            {createInvoice == false && (
              <>
                <Button
                  size="sm"
                  h="32px"
                  px={3}
                  borderRadius="md"
                  fontWeight={drawerMainTab === "comments" ? "600" : "500"}
                  bg={drawerMainTab === "comments" ? "white" : "transparent"}
                  boxShadow={drawerMainTab === "comments" ? "sm" : "none"}
                  color={drawerMainTab === "comments" ? "gray.800" : "gray.600"}
                  _hover={
                    drawerMainTab !== "comments"
                      ? { bg: "white", boxShadow: "sm", color: "gray.800" }
                      : {}
                  }
                  onClick={() => setDrawerMainTab("comments")}
                  leftIcon={
                    <Icon
                      as={IoChatbubbleEllipsesOutline}
                      boxSize={3.5}
                      color={drawerMainTab === "comments" ? "rekening.600" : "gray.500"}
                    />
                  }
                  transition="all 0.15s ease"
                >
                  {t("invoiceDetails.drawerTabComments")}
                </Button>
                <Button
                  size="sm"
                  h="32px"
                  px={3}
                  borderRadius="md"
                  fontWeight={drawerMainTab === "activity" ? "600" : "500"}
                  bg={drawerMainTab === "activity" ? "white" : "transparent"}
                  boxShadow={drawerMainTab === "activity" ? "sm" : "none"}
                  color={drawerMainTab === "activity" ? "gray.800" : "gray.600"}
                  _hover={
                    drawerMainTab !== "activity"
                      ? { bg: "white", boxShadow: "sm", color: "gray.800" }
                      : {}
                  }
                  onClick={() => setDrawerMainTab("activity")}
                  leftIcon={
                    <Icon
                      as={IoTimer}
                      boxSize={3.5}
                      color={drawerMainTab === "activity" ? "rekening.600" : "gray.500"}
                    />
                  }
                  transition="all 0.15s ease"
                >
                  {t("invoiceDetails.drawerTabActivityFeed")}
                </Button>
              </>
            )}
          </Box>

          {drawerMainTab === "settings" && (
            <VStack spacing={5} align="stretch">
          <InvoiceDrawerSection
            title={t("invoiceDetails.sectionBasic")}
            description={t("invoiceDetails.sectionBasicDesc")}
            icon={<IoInformationCircle />}
            collapsible={false}
          >
            <VStack spacing={3} align="stretch">
              <Box>
                <Text fontSize="smaller" mb="1" fontWeight="bold">
                  {t("invoiceDetails.name")}
                </Text>
                <Input
                  autoFocus={createInvoice}
                  placeholder={t("invoiceDetails.typeHere")}
                  value={editInvoice.shop}
                  disabled={!invoiceTypeNextStepAllowed}
                  onChange={(evt) => onChangeTextOpenInvoice(`shop`, evt.target.value)}
                  isInvalid={editInvoiceErrorArray.includes("shop")}
                />
              </Box>

              <Box>
                <Text fontSize="smaller" mb="1" fontWeight="bold">
                  {t("invoiceDetails.invoiceNumber")}
                </Text>
                <Input
                  placeholder={t("invoiceDetails.typeHere")}
                  value={editInvoice.invoiceNumber || ""}
                  disabled={!invoiceTypeNextStepAllowed}
                  onChange={(evt) => onChangeTextOpenInvoice(`invoiceNumber`, evt.target.value)}
                />
              </Box>

              <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                <GridItem>
                  <Box>
                    <Text fontSize="smaller" mb="1" fontWeight="bold">
                      {t("invoiceDetails.date")}
                    </Text>
                    {invoiceTypeNextStepAllowed && (
                      <DatePicker
                        renderInput={renderCustomInput}
                        value={selectedDay}
                        onChange={changeInvoiceDate}
                        colorPrimary="#1a5f3f"
                      ></DatePicker>
                    )}
                    {!invoiceTypeNextStepAllowed && (
                      <Input
                        placeholder={t("invoiceDetails.typeHere")}
                        value={selectedDay.day + "." + selectedDay.month + "." + selectedDay.year}
                        disabled={!invoiceTypeNextStepAllowed}
                      />
                    )}
                  </Box>
                </GridItem>
                <SelectCurrency
                  value={editInvoice.currency}
                  disabled={!invoiceTypeNextStepAllowed}
                  changeValue={onChangeTextOpenInvoice}
                />
              </Grid>
            </VStack>
          </InvoiceDrawerSection>

          <InvoiceDrawerSection
            title={t("invoiceDetails.sectionWorkflowBudget")}
            description={t("invoiceDetails.sectionWorkflowBudgetDesc")}
            icon={<IoCheckmarkCircle />}
            collapsible={false}
          >
            <VStack spacing={3} align="stretch">
              <SelectInvoiceType
                changeValue={onChangeTextOpenInvoice}
                value={editInvoice.invoiceType}
                disabled={editInvoice.invoiceType != undefined && editInvoice.invoiceType != "" && createInvoice == false}
                isInvalid={editInvoiceErrorArray.includes("invoiceType")}
                invoiceTypesData={invoiceTypesData}
              ></SelectInvoiceType>

              <SelectBudget
                changeValue={onChangeTextOpenInvoice}
                disabled={!invoiceTypeNextStepAllowed}
                value={editInvoice.category}
                categoriesData={categoriesData}
                isInvalid={editInvoiceErrorArray.includes("category")}
                session={session}
                api_url={api_url}
                invoiceDate={editInvoice.date}
              />
            </VStack>
          </InvoiceDrawerSection>

          <InvoiceDrawerSection
            title={t("invoiceDetails.sectionPartnerTransaction")}
            description={t("invoiceDetails.sectionPartnerTransactionDesc")}
            icon={<IoPersonCircleSharp />}
            collapsible={false}
          >
            <VStack spacing={4} align="stretch">
              {/* Trading Partner Selection */}
              <Box>
                <Text fontSize="smaller" mb="1" fontWeight="bold">
                  {t("invoiceDetails.tradingPartner")}
                </Text>
                {(() => {
                  const partnerData = (editInvoice as any).tradingPartnerData;
                  const partnerId = editInvoice.tradingPartner;

                  if (partnerData || partnerId) {
                    const displayPartner = partnerData || tradingPartnersData.find(p => p._id === partnerId);
                    
                    return (
                      <Box
                        p={3}
                        borderWidth={1}
                        borderRadius="md"
                        borderColor="blue.300"
                        bg="blue.50"
                      >
                        <Flex justifyContent="space-between" alignItems="center" gap={3}>
                          <HStack spacing={3} minW={0}>
                            <Avatar size="sm" name={displayPartner?.name} icon={<IoPersonCircleSharp />} />
                            <Box minW={0}>
                              <Text fontWeight="bold" noOfLines={1}>
                                {displayPartner?.name || t("invoiceDetails.loadingPartner")}
                              </Text>
                              <Text fontSize="xs" color="gray.600">
                                {displayPartner?.creditorNumber || displayPartner?.debitorNumber || ''}
                              </Text>
                            </Box>
                          </HStack>
                          {invoiceTypeNextStepAllowed && (
                            <HStack spacing={1}>
                              <Tooltip label={t("common.change") || "Change"}>
                                <IconButton
                                  aria-label="Change trading partner"
                                  icon={<IoRefresh />}
                                  size="sm"
                                  variant="ghost"
                                  colorScheme="blue"
                                  onClick={() => setIsTradingPartnerSelectorOpen(true)}
                                />
                              </Tooltip>
                              <Tooltip label={t("common.delete") || "Delete"}>
                                <IconButton
                                  aria-label="Remove trading partner"
                                  icon={<IoCloseCircle />}
                                  size="sm"
                                  variant="ghost"
                                  colorScheme="red"
                                  onClick={() => {
                                    onChangeTextOpenInvoice("tradingPartner", "");
                                    (editInvoice as any).tradingPartnerData = null;
                                  }}
                                />
                              </Tooltip>
                            </HStack>
                          )}
                        </Flex>
                      </Box>
                    );
                  }

                  return (
                    <Button
                      width="full"
                      leftIcon={<IoAddCircle />}
                      onClick={() => setIsTradingPartnerSelectorOpen(true)}
                      isDisabled={!invoiceTypeNextStepAllowed}
                      variant="outline"
                      colorScheme="rekening"
                    >
                      {t("invoiceDetails.selectTradingPartner") || "Select Trading Partner"}
                    </Button>
                  );
                })()}
              </Box>

              {/* Transaction Selection/Display */}
              <Box>
                <Flex alignItems="center" mb="1" gap={2}>
                  <Text fontSize="smaller" fontWeight="bold">
                    {t("invoiceDetails.linkedTransactions")}
                  </Text>
                  {linkedTransactions.length > 0 && (
                    <Badge colorScheme="green" fontSize="2xs">
                      {t("invoiceDetails.paymentCount", { count: linkedTransactions.length })}
                    </Badge>
                  )}
                </Flex>
                {linkedTransactions.length > 0 && (
                  <VStack spacing={2} align="stretch" mb={2}>
                    {linkedTransactions.map((lt) => {
                      const txd = lt.transactionDetails;
                      if (!txd) return null;
                      return (
                        <Box
                          key={lt._id}
                          p={3}
                          borderWidth={1}
                          borderRadius="md"
                          borderColor="green.300"
                          bg="green.50"
                        >
                          <Flex justifyContent="space-between" alignItems="center" gap={3}>
                            <Box minW={0}>
                              <Text fontWeight="bold" color="green.700" noOfLines={1}>
                                <IoCheckmarkCircle
                                  style={{
                                    display: "inline",
                                    marginRight: "8px",
                                    verticalAlign: "middle",
                                  }}
                                />
                                {t("invoiceDetails.linkedTransaction")}
                              </Text>
                              <Text fontSize="sm" mt={1} noOfLines={1}>
                                {new Date(txd.transactionDate).toLocaleDateString("de-DE")} -{" "}
                                {txd.counterparty} - {typeof txd.amount === "number" ? txd.amount.toFixed(2) : txd.amount}{" "}
                                {txd.currency || "€"}
                              </Text>
                              {txd.reference && (
                                <Text fontSize="xs" color="gray.600" mt={1} noOfLines={2}>
                                  {txd.reference}
                                </Text>
                              )}
                            </Box>
                            {invoiceTypeNextStepAllowed && (
                              <Button
                                size="sm"
                                variant="ghost"
                                colorScheme="red"
                                onClick={() => {
                                  const newIds = linkedTransactions
                                    .map((l) => l.transaction)
                                    .filter((id) => id !== lt.transaction);
                                  const nextLinked = linkedTransactions.filter(
                                    (l) => l.transaction !== lt.transaction
                                  );
                                  setLinkedTransactions(nextLinked);
                                  let openInvoiceData = newInvoice;
                                  if (createInvoice == false) {
                                    openInvoiceData = rekeningData[selectedInvoice];
                                  }
                                  (openInvoiceData as any).linkedTransactionIds = newIds;
                                  (openInvoiceData as any).linkedTransactions = nextLinked;
                                  saveInvoiceData(openInvoiceData);
                                }}
                              >
                                <IoCloseCircle style={{ marginRight: "4px" }} />
                                {t("invoiceDetails.unlinkTransaction")}
                              </Button>
                            )}
                          </Flex>
                        </Box>
                      );
                    })}
                    {(() => {
                      const inv = editInvoice as any;
                      const invoiceTotal = parseFloat(editInvoice.total) || 0;
                      const paidSum = inv.linkedTransactionAmountSum != null
                        ? Math.abs(inv.linkedTransactionAmountSum)
                        : linkedTransactions.reduce((sum, lt) => sum + Math.abs(lt.transactionDetails?.amount || 0), 0);
                      const remaining = inv.remainingAmount != null
                        ? inv.remainingAmount
                        : Math.max(0, invoiceTotal - paidSum);
                      return (
                        <Box p={2} borderRadius="md" bg="gray.50">
                          <Text fontSize="xs" color="gray.600">
                            {t("invoiceDetails.paidAmount", {
                              paid: paidSum.toFixed(2),
                              total: invoiceTotal.toFixed(2),
                              currency: editInvoice.currency || "EUR",
                            })}
                          </Text>
                          {remaining > 0 && (
                            <Text fontSize="xs" color="orange.600" fontWeight="bold">
                              {t("invoiceDetails.remainingAmount")}: {remaining.toFixed(2)} {editInvoice.currency || "EUR"}
                            </Text>
                          )}
                        </Box>
                      );
                    })()}
                  </VStack>
                )}
                <Button
                  width="full"
                  leftIcon={<IoAddCircle />}
                  onClick={() => setIsTransactionSelectorOpen(true)}
                  isDisabled={!invoiceTypeNextStepAllowed}
                  variant="outline"
                  colorScheme="rekening"
                  size={linkedTransactions.length > 0 ? "sm" : "md"}
                >
                  {t("invoiceDetails.selectTransaction") || "Link Transaction"}
                </Button>
              </Box>
            </VStack>
          </InvoiceDrawerSection>

          <InvoiceDrawerSection
            title={t("invoiceDetails.sectionAccounting")}
            description={t("invoiceDetails.sectionAccountingDesc")}
            icon={<IoCash />}
            collapsible={false}
          >
            <VStack spacing={4} align="stretch">
              <Box>
                <Text fontSize="smaller" mb="1" fontWeight="bold">
                  {t("invoiceDetails.transactionType")}
                </Text>
                <ChakraReactSelect
                  placeholder={t("invoiceDetails.transactionType")}
                  value={
                    editInvoice.transactionType
                      ? {
                          label:
                            editInvoice.transactionType === "incoming"
                              ? t("invoiceDetails.incoming")
                              : t("invoiceDetails.outgoing"),
                          value: editInvoice.transactionType,
                        }
                      : null
                  }
                  isDisabled={!invoiceTypeNextStepAllowed}
                  onChange={(selectedOption) =>
                    onChangeTextOpenInvoice("transactionType", selectedOption?.value || "incoming")
                  }
                  options={[
                    { label: t("invoiceDetails.incoming"), value: "incoming" },
                    { label: t("invoiceDetails.outgoing"), value: "outgoing" },
                  ]}
                  isSearchable={false}
                  isClearable={false}
                  size="md"
                  menuPortalTarget={typeof window !== "undefined" ? document.body : null}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                  }}
                />
              </Box>

              <Box>
                <Flex align="center" justify="space-between" mb="1">
                  <Text fontSize="smaller" fontWeight="bold">
                    {t("invoiceDetails.bookingEntries") || "Buchungssätze"}
                  </Text>
                  {invoiceTypeNextStepAllowed == true && (
                    <Button
                      size="xs"
                      variant="outline"
                      onClick={editInvoiceAddBookingEntry}
                      leftIcon={<IoAddCircle />}
                    >
                      {t("invoiceDetails.addBookingEntry") || "Hinzufügen"}
                    </Button>
                  )}
                </Flex>

                {bookingEntries.length === 0 ? (
                  <Text fontSize="sm" color="gray.500">
                    {t("invoiceDetails.noBookingEntries") || "Noch keine Buchungssätze angelegt."}
                  </Text>
                ) : (
                  <Box>
                    {bookingEntries.map((entry, index) => {
                      const canRemove = invoiceTypeNextStepAllowed == true;
                      return (
                        <Box
                          key={(entry as any)?._id || `${index}-booking-entry`}
                          mt={index === 0 ? 0 : 3}
                          p={3}
                          bg="gray.50"
                          borderWidth={1}
                          borderColor="gray.200"
                          borderRadius="md"
                        >
                          {/* Row 1: Brutto - MWSt - BU Schlüssel */}
                          <Grid templateColumns={{ base: "1fr", md: "repeat(14, 1fr)" }} gap={3}>
                            <GridItem colSpan={{ base: 14, md: 8 }}>
                              <Text fontSize="smaller" mb="1" fontWeight="bold">
                                {t("invoiceDetails.grossAmount") || "Brutto"}
                              </Text>
                              <CurrencyInput
                                key={`${openedInvoiceKey}-booking-${index}-amount`}
                                className={"like-chakra-input"}
                                placeholder={t("invoiceDetails.enterNumber")}
                                defaultValue={entry?.amount || ""}
                                decimalsLimit={2}
                                allowNegativeValue={false}
                                intlConfig={currencyInputConfig}
                                step={1}
                                onValueChange={(value, name, values) =>
                                  onChangeBookingEntry(
                                    index,
                                    "amount",
                                    values?.float != null ? values.float.toFixed(2).toString() : ""
                                  )
                                }
                                disabled={!invoiceTypeNextStepAllowed}
                              />
                            </GridItem>

                            <GridItem colSpan={{ base: 14, md: 6 }}>
                              <Text fontSize="smaller" mb="1" fontWeight="bold">
                                {t("invoiceDetails.buSchluessel") || "BU-Schlüssel"}
                              </Text>
                              <BuKeySelect
                                value={entry?.buSchluessel || ""}
                                isDisabled={!invoiceTypeNextStepAllowed}
                                placeholder={t("invoiceDetails.selectBuKey") || "BU-Schlüssel auswählen..."}
                                onChange={(next) => onChangeBookingEntry(index, "buSchluessel", next)}
                              />
                            </GridItem>
                          </Grid>

                          {/* Row 2: Buchungskonto */}
                          <Box mt={3}>
                            <Text fontSize="smaller" mb="1" fontWeight="bold">
                              {t("invoiceDetails.bookingAccountSkr3") || "Buchungskonto (SKR03)"}
                            </Text>
                            <BookingAccountSkr3Select
                              value={entry?.account || ""}
                              isDisabled={!invoiceTypeNextStepAllowed}
                              placeholder={t("invoiceDetails.selectBookingAccount")}
                              onChange={(next) => onChangeBookingEntry(index, "account", next)}
                            />
                          </Box>

                          {/* Row 3: Buchungstext + Remove icon */}
                          <Box mt={3}>
                            <Text fontSize="smaller" mb="1" fontWeight="bold">
                              {t("invoiceDetails.bookingText") || "Buchungstext"}
                            </Text>
                            <Flex gap={2} align="center">
                              <Input
                                placeholder={t("invoiceDetails.typeHere")}
                                value={entry?.bookingText || ""}
                                onChange={(evt) => onChangeBookingEntry(index, "bookingText", evt.target.value)}
                                disabled={!invoiceTypeNextStepAllowed}
                              />
                              <IconButton
                                aria-label={t("invoiceDetails.remove") || "Entfernen"}
                                icon={<IoTrash fontSize={"18px"} />}
                                variant="outline"
                                colorScheme="red"
                                size="sm"
                                onClick={() => editInvoiceRemoveBookingEntry(index)}
                                isDisabled={!canRemove}
                              />
                            </Flex>
                          </Box>
                        </Box>
                      );
                    })}
              </Box>
                )}

                {bookingValidationActive && (
                  <Alert
                    mt={4}
                    status={bookingEntriesSumValid ? "success" : "error"}
                    variant="left-accent"
                  >
                    <AlertIcon />
                    <Box>
                      <Text fontSize="sm">
                        {bookingEntriesSumValid
                          ? t("invoiceDetails.bookingEntriesSumOk") || "Summe der Buchungssätze ist korrekt."
                          : t("invoiceDetails.bookingEntriesSumError") ||
                            "Summe der Buchungssätze muss dem Bruttobetrag der Rechnung entsprechen."}
                      </Text>
                      <Text fontSize="xs" color="gray.600">
                        {(t("invoiceDetails.bookingEntriesSumHint") || "Buchungssätze: {{bookings}} / Brutto: {{gross}}")
                          .replace("{{bookings}}", (bookingEntriesSumCents / 100).toFixed(2))
                          .replace("{{gross}}", (invoiceTotalCents / 100).toFixed(2))}
                        {" "}
                        {editInvoice.currency}
                      </Text>
                    </Box>
                  </Alert>
                )}
              </Box>

              <Box>
                <Text fontSize="smaller" mb="1" fontWeight="bold">
                  {t("invoiceDetails.clearingAccount")}
                </Text>
                <ChakraReactSelect
                  placeholder={t("invoiceDetails.selectClearingAccount")}
                  value={
                    editInvoice.clearingAccount
                      ? {
                          label: `${
                            clearingAccountsData.find(
                              (account) => account._id === editInvoice.clearingAccount
                            )?.accountNumber || ""
                          } - ${
                            clearingAccountsData.find(
                              (account) => account._id === editInvoice.clearingAccount
                            )?.name || ""
                          }`,
                          value: editInvoice.clearingAccount,
                        }
                      : null
                  }
                  isDisabled={!invoiceTypeNextStepAllowed}
                  onChange={(selectedOption) =>
                    onChangeTextOpenInvoice("clearingAccount", selectedOption?.value || "")
                  }
                  options={clearingAccountsData.map((account) => ({
                    label: `${account.accountNumber} - ${account.name}`,
                    value: account._id,
                  }))}
                  isSearchable={true}
                  isClearable={true}
                  size="md"
                  menuPortalTarget={typeof window !== "undefined" ? document.body : null}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                  }}
                />
              </Box>
            </VStack>
          </InvoiceDrawerSection>

          {"travelExpense" in editInvoice && (
            <InvoiceDrawerSection
              title={t("invoiceDetails.sectionTravelExpense")}
              description={t("invoiceDetails.sectionTravelExpenseDesc")}
              icon={<IoBriefcase />}
              collapsible={false}
            >
              <TravelExpensesElement
                changeTravelExpenseLocation={changeTravelExpenseLocation}
                invoiceData={editInvoice}
                updateMeals={updateMeals}
                invoiceTypeNextStepAllowed={invoiceTypeNextStepAllowed}
                editInvoiceErrorArray={editInvoiceErrorArray}
                countryListAllowance={countryListAllowance}
                travelExpense={editInvoice.travelExpense}
                readOnlyAdminFields={false}
                changeText={onChangeTextTravelExpense}
              ></TravelExpensesElement>
            </InvoiceDrawerSection>
          )}

          {editInvoice.invoiceKind != "travel-expense" && (
            <InvoiceDrawerSection
              title={t("invoiceDetails.sectionAmounts")}
              description={t("invoiceDetails.sectionAmountsDesc")}
              icon={<IoCash />}
              collapsible={false}
              rightElement={
                invoiceTypeNextStepAllowed == true &&
                editInvoice.invoiceKind != "travel-expense" &&
                (editInvoice.taxPositions != undefined && editInvoice.taxPositions.length != 0) ? (
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={editInvoiceAddTaxRate}
                    leftIcon={<IoAddCircle />}
                  >
                    {t("invoiceDetails.taxRates")}
                  </Button>
                ) : null
              }
            >
              {(editInvoice.taxPositions == undefined || editInvoice.taxPositions.length == 0) && (
                <Box>
                  <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                    <GridItem colSpan={1}>
                      <Text fontSize="smaller" mb="1" fontWeight="bold">
                        {t("invoiceDetails.amountIn")}
                        {editInvoice.currency}
                      </Text>
                      <Input
                        placeholder="0"
                        value={editInvoice.total}
                        onChange={(evt) => onChangeTotalOpenInvoice(`value`, evt.target.value, 0)}
                        type="number"
                        min="0"
                        disabled={!invoiceTypeNextStepAllowed}
                        isInvalid={editInvoiceErrorArray.includes("amount")}
                      />
                    </GridItem>
                    <GridItem colSpan={1}>
                      <Text fontSize="smaller" mb="1" fontWeight="bold">
                        {t("invoiceDetails.vatIn")}
                      </Text>
                      <Input
                        placeholder={t("invoiceDetails.typeHere")}
                        value={editInvoice.mwst}
                        onChange={(evt) => onChangeTotalOpenInvoice(`taxRate`, evt.target.value, 0)}
                        type="number"
                        min="0"
                        max="100"
                        disabled={!invoiceTypeNextStepAllowed}
                      />
                    </GridItem>
                  </Grid>
                </Box>
              )}

              {(editInvoice.taxPositions != undefined && editInvoice.taxPositions.length != 0) &&
                editInvoice.invoiceKind != "travel-expense" && (
                  <Box>
                    {editInvoice.taxPositions.map((singleTaxPosition, index) => {
                      let addRemoveButton = false;
                      if (index > 0) {
                        addRemoveButton = true;
                      }

                      return (
                        <Grid
                          key={index + "-tax"}
                          mt="2"
                          templateColumns={{ base: "1fr", md: "repeat(14, 1fr)" }}
                          gap={3}
                        >
                          <GridItem colSpan={{ base: 14, md: 4 }}>
                            <Text fontSize="smaller" mb="1" fontWeight="bold">
                              {t("invoiceDetails.grossAmount")}
                            </Text>
                            <CurrencyInput
                              key={`${openedInvoiceKey}-tax-${index}-value`}
                              className={
                                "like-chakra-input" +
                                (editInvoiceErrorArray.includes("amount") ? " invalid" : "")
                              }
                              placeholder={t("invoiceDetails.enterNumber")}
                              defaultValue={singleTaxPosition.value}
                              decimalsLimit={2}
                              allowNegativeValue={false}
                              intlConfig={currencyInputConfig}
                              step={1}
                              onValueChange={(value, name, values) =>
                                onChangeTotalOpenInvoice(`value`, values.float, index)
                              }
                            />
                          </GridItem>
                          <GridItem colSpan={{ base: 14, md: 4 }}>
                            <Text fontSize="smaller" mb="1" fontWeight="bold">
                              {t("invoiceDetails.netAmount")}
                            </Text>
                            <CurrencyInput
                              key={`${openedInvoiceKey}-tax-${index}-valueNet`}
                              className={
                                "like-chakra-input" +
                                (editInvoiceErrorArray.includes("amountNet") ? " invalid" : "")
                              }
                              placeholder={t("invoiceDetails.enterNumber")}
                              defaultValue={singleTaxPosition.valueNet}
                              decimalsLimit={2}
                              allowNegativeValue={false}
                              intlConfig={currencyInputConfig}
                              step={1}
                              onValueChange={(value, name, values) =>
                                onChangeTotalOpenInvoice(`valueNet`, values.float, index)
                              }
                              disabled={!invoiceTypeNextStepAllowed || editInvoice.invoiceKind == "travel-expense"}
                            />
                          </GridItem>
                          <GridItem colSpan={{ base: 14, md: 4 }}>
                            <Text fontSize="smaller" mb="1" fontWeight="bold">
                              {t("invoiceDetails.taxAmount")}
                            </Text>
                            <CurrencyInput
                              key={`${openedInvoiceKey}-tax-${index}-valueTax`}
                              className={
                                "like-chakra-input" +
                                (editInvoiceErrorArray.includes("amount") ? " invalid" : "")
                              }
                              placeholder={t("invoiceDetails.enterNumber")}
                              defaultValue={(singleTaxPosition as any).valueTax}
                              decimalsLimit={2}
                              allowNegativeValue={false}
                              intlConfig={currencyInputConfig}
                              step={1}
                              onValueChange={(value, name, values) =>
                                onChangeTotalOpenInvoice(`valueTax`, values.float, index)
                              }
                            />
                          </GridItem>
                          <GridItem colSpan={{ base: 14, md: 2 }}>
                            <Text fontSize="smaller" mb="1" fontWeight="bold">
                              {t("invoiceDetails.vatIn")}
                            </Text>
                            <CurrencyInput
                              key={`${openedInvoiceKey}-tax-${index}-taxRate`}
                              className={
                                "like-chakra-input" +
                                (editInvoiceErrorArray.includes("taxRate") ? " invalid" : "")
                              }
                              placeholder={t("invoiceDetails.enterNumber")}
                              defaultValue={singleTaxPosition.taxRate}
                              decimalsLimit={2}
                              allowNegativeValue={false}
                              intlConfig={currencyInputConfig}
                              step={1}
                              maxLength={2}
                              onValueChange={(value, name, values) =>
                                onChangeTotalOpenInvoice(`taxRate`, values.float, index)
                              }
                              disabled={!invoiceTypeNextStepAllowed || editInvoice.invoiceKind == "travel-expense"}
                              suffix={" %"}
                            />
                          </GridItem>

                          {addRemoveButton && invoiceTypeNextStepAllowed == true && (
                            <GridItem colSpan={{ base: 12, md: 12 }} display="flex" justifyContent="flex-end">
                              <Button
                                mt={{ base: 0, md: 2 }}
                                onClick={(e) => editInvoiceRemoveTaxRate(index)}
                                leftIcon={<IoRemoveCircle fontSize={"18px"} />}
                                size="sm"
                                variant="outline"
                              >
                                {t("invoiceDetails.remove")}
                              </Button>
                            </GridItem>
                          )}
                        </Grid>
                      );
                    })}
                  </Box>
                )}
            </InvoiceDrawerSection>
          )}

          {editInvoice.invoiceKind === "invoice" && (
            <InvoiceDrawerSection
              title={t("invoiceDetails.sectionDocument")}
              description={t("invoiceDetails.sectionDocumentDesc")}
              icon={<IoDocumentAttachOutline />}
              collapsible={false}
              rightElement={
                invoiceTypeNextStepAllowed == true ? (
                  <Button
                    size="sm"
                    variant="outline"
                    isLoading={uploadInProgress}
                    onClick={() => fileInputRef.current && fileInputRef.current.click()}
                    leftIcon={<IoCloudUpload fontSize={"18px"} />}
                    isDisabled={attachmentUrl !== ""}
                  >
                    {t("invoiceDetails.uploadInvoice")}
                  </Button>
                ) : null
              }
            >
              <input
                ref={fileInputRef}
                style={{ display: "none" }}
                type="file"
                id="file-upload"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  if (attachmentUrl !== "") {
                    userNotification(
                      t("invoiceDetails.documentAlreadyAttachedTitle"),
                      t("invoiceDetails.documentAlreadyAttachedDesc"),
                      "warning"
                    );
                    return;
                  }
                  uploadFile(file, false, true);
                }}
              />

              {attachmentUrl !== "" && (
                <Text fontSize="sm" color="gray.600">
                  {t("invoiceDetails.documentManagedInPreviewHint")}
                </Text>
              )}

              {attachmentUrl === "" && (
                <Text fontSize={"smaller"} mb={"1"} fontWeight={"bold"}>
                  {t("invoiceDetails.noDocument")}
                </Text>
              )}
            </InvoiceDrawerSection>
          )}

          {createInvoice == false && invoiceTypeNextStepAllowed == true && (
            <Flex justify="flex-end" pt={4} mt={1} borderTopWidth="1px" borderColor="gray.200">
              <Button
                size="sm"
                variant="outline"
                colorScheme="red"
                leftIcon={<IoTrash />}
                onClick={() => setIsDeleteOpen(true)}
              >
                {deleteInvoiceHeaderLabel}
              </Button>
            </Flex>
          )}
            </VStack>
          )}

          {drawerMainTab === "comments" && createInvoice == false && (
            <VStack spacing={5} align="stretch">
            <InvoiceDrawerSection
              title={t("comments.sectionTitle")}
              description={t("comments.sectionDesc")}
              icon={<IoChatbubbleEllipsesOutline />}
              defaultOpen={true}
              collapsible={false}
            >
              <InvoiceCommentsSection
                apiUrl={api_url}
                invoice={editInvoice}
                invoiceId={editInvoice?._id}
                session={session}
                userData={userData}
                onRefresh={() => loadSingleInvoices(editInvoice._id)}
              />
            </InvoiceDrawerSection>
            </VStack>
          )}

          {drawerMainTab === "activity" && createInvoice == false && (
            <VStack spacing={5} align="stretch">
            <InvoiceDrawerSection
              title={t("invoiceDetails.sectionChangelog")}
              description={t("invoiceDetails.sectionChangelogOpen")}
              icon={<IoTimer />}
              collapsible={false}
            >
              <ChangeLogElement
                userData={userData}
                value={editInvoice.changelog}
                compact={true}
                withAccordion={false}
              ></ChangeLogElement>
            </InvoiceDrawerSection>
            </VStack>
          )}

        </VStack>
      </DrawerBody>

      <DrawerFooter style={{borderTop: "1px solid #e2e8f0"}}>
        <SimpleGrid  width={"100%"} columns={1}>
        <InvoiceStatusElement typeName="Invoice" createInvoice={createInvoice} nextStepAllowed={invoiceTypeNextStepAllowed} invoiceTypesData={invoiceTypesData} invoiceType={editInvoice.invoiceType} invoiceStatus={editInvoice.invoiceStatus} changeValue={editInvoiceStatusUpdate}></InvoiceStatusElement>
        <Flex mt={5}>
        {createInvoice != true &&
        <Button mr={3} onClick={previewBackwards} variant="outline">
          <IoChevronBack/>
        </Button>
        }
        {createInvoice != true &&
        <Button mr={3} onClick={previewForwards} variant="outline">
          <IoChevronForwardOutline/>
        </Button>
        }
        {createInvoice != true && editInvoice.invoiceKind == "travel-expense" &&
          <Button mr="3" variant='outline' onClick={()=>printTravelExpense(editInvoice._id)}>
              <IoPrint/>
              <Text ml="2">
              {t("invoiceDetails.print")}
              </Text>
          </Button>
        }
        <Spacer></Spacer>
        <Button mr={3} onClick={closeInvoice} variant="outline">
        {t("invoiceDetails.cancelClose")}
        </Button>
        {(createInvoice == false && invoiceTypeNextStepAllowed == true) &&
        <Button
          onClick={saveInvoice}
          isLoading={saveInvoiceLoading}
          isDisabled={!editInvoiceModified || !bookingEntriesSumValid}
          colorScheme="rekening"
        >
          <IoSave></IoSave>
          <Text ml="2">
          {t("invoiceDetails.saveChanges")}
          </Text>
        </Button>
        }
        {createInvoice == true &&
        <Button onClick={saveInvoice} isLoading={saveInvoiceLoading} isDisabled={!bookingEntriesSumValid} colorScheme="rekening">
          <IoSave></IoSave>
          {editInvoice.invoiceKind == "travel-expense" &&
            <Text ml="2">
              {t("invoiceDetails.addTravelExpense")}
            </Text>
          }
          {editInvoice.invoiceKind == "invoice" &&
            <Text ml="2">
              {t("invoiceDetails.addInvoice")}
            </Text>
          }
        </Button>
        }
        </Flex>
        </SimpleGrid>
      </DrawerFooter>
    </DrawerContent>
    {invoiceIsOpen && attachmentUrl !== "" && (
      <InvoiceAttachmentPreviewPanel
        invoiceId={editInvoice?._id}
        attachmentUrl={attachmentUrl}
        isPdf={isPdfPreviewOpen}
        invoiceKind={editInvoice.invoiceKind}
        shop={editInvoice.shop}
        dateIso={editInvoice.date}
        invoiceNumber={editInvoice.invoiceNumber || ""}
        total={String(editInvoice.total)}
        totalNet={String(editInvoice.totalNet)}
        tax={String(editInvoice.tax)}
        currency={editInvoice.currency}
        canEditAttachment={
          invoiceTypeNextStepAllowed == true && editInvoice.invoiceKind == "invoice"
        }
        onRemoveAttachment={removeImageFromInvoice}
      />
    )}
  </Drawer>


      
    <Modal isOpen={isCloseEditWithoutSave} onClose={onCloseEditWithoutSaveClose}>
        <ModalOverlay/>
        <ModalContent>
          <ModalHeader>{t("invoiceDetails.closeWithoutSaving")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>{t("invoiceDetails.sureToClose")}</Text>
          </ModalBody>
          <ModalFooter>
            <Button onClick={()=>{onCloseEditWithoutSaveClose(); closeInvoice()}} mr={3} variant="outline">{t("invoiceDetails.cancelClose")}</Button>
            <Button
              onClick={()=>{saveInvoice(); onCloseEditWithoutSaveClose();}}
              mr={3}
              colorScheme="rekening"
              isDisabled={!bookingEntriesSumValid}
            >
              <IoCheckmarkDoneCircleSharp style={{fontSize: "1.2em", marginRight:"5px"}}></IoCheckmarkDoneCircleSharp>
              {t("invoiceDetails.saveAndClose")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <TradingPartnerManager 
        isOpen={isOpenTradingPartnerManager} 
        onClose={() => setIsOpenTradingPartnerManager(false)} 
        updateTradingPartnerData={updateTradingPartnerData} 
        setUpdateTradingPartnerData={setUpdateTradingPartnerData} 
        insertTradingPartner={isInsertTradingPartner} 
        session={session} 
        loadTradingPartners={loadTradingPartners} 
      />

      {session && (
        <TransactionSelectorDrawer
          isOpen={isTransactionSelectorOpen}
          onClose={() => setIsTransactionSelectorOpen(false)}
          onSelect={(tx: TransactionSelectorItem) => {
            const currentIds = linkedTransactions.map((lt) => lt.transaction);
            if (currentIds.includes(tx._id)) return;
            const newIds = [...currentIds, tx._id];
            const newLink = {
              _id: `local-${tx._id}-${Date.now()}`,
              transaction: tx._id,
              transactionDetails: {
                transactionDate: tx.transactionDate,
                counterparty: tx.counterparty,
                amount: tx.amount,
                currency: tx.currency,
                reference: tx.reference,
              },
            };
            const nextLinked = [...linkedTransactions, newLink];
            setLinkedTransactions(nextLinked);

            let openInvoiceData = newInvoice;
            if (createInvoice == false) {
              openInvoiceData = rekeningData[selectedInvoice];
            }
            (openInvoiceData as any).linkedTransactionIds = newIds;
            (openInvoiceData as any).linkedTransactions = nextLinked;
            saveInvoiceData(openInvoiceData);
          }}
          apiUrl={api_url}
          session={session}
          excludeTransactionIds={linkedTransactions.map(lt => lt.transaction)}
        />
      )}

      {session && (
        <TradingPartnerSelectorDrawer
          isOpen={isTradingPartnerSelectorOpen}
          onClose={() => setIsTradingPartnerSelectorOpen(false)}
          onSelect={(partner) => {
            onChangeTextOpenInvoice("tradingPartner", partner._id);
            (editInvoice as any).tradingPartnerData = partner;
          }}
          apiUrl={api_url}
          session={session}
          onCreateNew={openCreateTradingPartner}
        />
      )}

  </div>
  ) : null;
  
  return modalContent
};

export default InvoiceDetailDrawer;